/**
 * Phone Number Normalizer Utility
 * Normalizes phone numbers by removing all non-numeric characters
 */
/**
 * Normalize a phone number by removing all non-numeric characters
 * @param phone - Phone number string (may contain dashes, spaces, parentheses, etc.)
 * @returns Digits-only string or null if input is null/empty
 */
export function normalizePhoneNumber(phone) {
    if (!phone) {
        return null;
    }
    // Remove all non-numeric characters
    const cleaned = phone.replace(/\D/g, "");
    // Return null if empty after cleaning, otherwise return cleaned version
    return cleaned || null;
}
/**
 * Validate that a phone number is exactly 10 digits
 * @param phone - Phone number string (should already be normalized)
 * @returns True if valid 10-digit phone number
 */
export function isValidPhoneNumber(phone) {
    if (!phone) {
        return false;
    }
    return /^\d{10}$/.test(phone);
}
/**
 * Format a phone number for display (e.g., "8658501277" -> "(865) 850-1277")
 * @param phone - Normalized 10-digit phone number
 * @returns Formatted phone number or original if not 10 digits
 */
export function formatPhoneNumber(phone) {
    if (!phone || phone.length !== 10) {
        return phone || "";
    }
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
}
